/**Converts a number to a string formatted as currency.
 */
export default function (number: number) {
  const USD = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })
  return USD.format(number)
}
